export default __webpack_public_path__ + "static/media/LuckyElectricPowerCompanyLogo.2564b7bb.jpg";